<template>
  <div>
    <chartjs-pie-card
      v-if="dataIsNotEmpty"
      :chart-data="chartData"
      :chart-options="chartOptions"
      style="/*min-height:475px*/"
    >
      <template slot="header">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="d-flex">
              <div class="card-title diligencePieChartTitle">Diligence Stage</div>
              <div
                style="margin-left: 5px; margin-top: auto;margin-bottom: auto;"
                v-tooltip.top-end="toolTipInfo"
              >
                <img src="static/img/graphInfo.svg" class />
              </div>
            </div>
          </div>
          <div>
            <el-select
              class="dashboard-dropdown-el-select select-primary"
              size="small"
              placeholder="Select Value Graph"
              v-model="category.selected"
              @change="categoryChange"
            >
              <el-option
                v-for="option in categoryDropdown"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </div>
        </div>
      </template>
    </chartjs-pie-card>
  </div>
</template>
<script>
import { vals, formatCurrency, subsetBackground } from "../../../util";
import { ChartjsPieCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
import { Select, Option } from "element-ui";
export default {
  name: "pie-diligence-chart-card",
  components: {
    [ChartjsPieCard.name]: ChartjsPieCard,
    [Option.name]: Option,
    [Select.name]: Select
  },
  props: {
    cutoutPercentage: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
      dataIsEmpty: true,
      datasets: [],
      labels: [],
      textCenterLabel: [],
      category: {
        selected: "sector",
        title: "Sector"
      }
    };
  },
  computed: {
    ...mapGetters("charts", ["diligenceData"]),
    ...mapGetters("diligence", ["diligenceCount"]),
    ...mapGetters("diligence_stage", ["diligenceStageCount"]),
    chartData() {
      const self = this;
      let data = {
        labels: _.flatten(self.computedLabels),
        datasets: self.computedDataset
      };
      return data;
    },
    chartOptions() {
      const self = this;
      let totalCountObj = {
        text: self.diligenceCount,
        font: {
          size: "25",
          family: "custom-helvetica-medium,roboto"
        },
        color: "#050505"
      };
      self.textCenterLabel[0] = totalCountObj;
      let options = {
        cutoutPercentage: this.cutoutPercentage,
        plugins: {
          doughnutlabel: {
            labels: this.textCenterLabel
          }
        },
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function(toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].header_label[
                  toolTipItem.index
                ] || "") +
                ": " +
                (data.datasets[toolTipItem.datasetIndex].data[
                  toolTipItem.index
                ] || "") +
                "%"
              );
            },
            footer: function(toolTips, data) {
              let toolTipItem = toolTips[0];
              let value =
                data.datasets[toolTipItem.datasetIndex].data_value[
                  toolTipItem.index
                ] || 0;
              return value > 1 ? `${value} Companies` : `${value} Company`;
            }
          }
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false
        },
        onClick: function(unused, toolTips) {
          let toolTipItem = toolTips[0];
          if (!_.isNil(toolTipItem)) {
            if (toolTipItem._datasetIndex === 0) {
              // only 'drill-down' if it is a primary value
              let data = toolTipItem._chart.data;
              let propertyValue =
                data.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              self.addDatasetForProperty(propertyValue, toolTipItem._index);
              let diligenceDataValue =
                data.datasets[toolTipItem._datasetIndex].data_value[
                  toolTipItem._index
                ];
              let obj = {
                text: propertyValue,
                font: {
                  size: "12",
                  family: "custom-helvetica-medium,roboto"
                },
                color: "#050505"
              };
              let dataObj = {
                text: diligenceDataValue,
                font: {
                  size: "25",
                  family: "custom-helvetica-medium,roboto"
                },
                color: "#050505"
              };
              self.textCenterLabel[0] = obj;
              self.textCenterLabel[1] = dataObj;
            } else if (toolTipItem._datasetIndex === 1) {
              // second tier
              // if label has 'Other' then we want to show table data
              let drillData = toolTipItem._chart.data;
              let drillPropertyValue =
                drillData.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              // make sure we have a path and that the path has 'Other' as its leaf
              if (drillPropertyValue.includes("/")) {
                let split = drillPropertyValue.split("/");
                let drillCompanyData = self.diligenceData(
                  self.category.selected
                ).groupByData[split[0].trim()];
                let actualCompany = drillCompanyData.find(item => {
                  if (item.name == split[1].trim()) {
                    return item;
                  }
                });
                let account_id = self.$route.params.account_id;
                let workspace_id = actualCompany.workspace;
                let ucid = actualCompany.ucid;
                self.$store.commit("temp/currentCompany", ucid);
                self.$router.push(
                  `/${account_id}/${workspace_id}/companyProfile/${ucid}`
                );
              }
            }
          }
        }
      };
      return options;
    },
    computedDataset() {
      return this.datasets;
    },
    computedLabels() {
      return this.labels;
    },
    dataIsNotEmpty() {
      return this.diligenceData(this.category.selected).totalDataLength > 0;
    },
    categoryDropdown() {
      let dropDownArray = [];
      dropDownArray[0] = { label: "By Sector", value: "sector" };
      dropDownArray[1] = { label: "By Current Stage", value: "stage" };
      dropDownArray[2] = {
        label: "By Diligence Stage",
        value: "dealStageName"
      };
      dropDownArray[3] = { label: "By Geography", value: "geography" };
      dropDownArray[4] = { label: "By Status", value: "status" };
      return dropDownArray;
    },
    toolTipInfo() {
      if (this.category.selected == "sector") {
        return "Shows the number of companies across sectors";
      }
      if (this.category.selected == "stage") {
        return "Shows the number of companies across stages";
      }
      if (this.category.selected == "dealStageName") {
        return "Shows the number of companies across diligence stages";
      }
      if (this.category.selected == "geography") {
        return "Shows the number of companies across geographies";
      }
      if (this.category.selected == "status") {
        return "Shows the number of companies across statuses";
      }
    }
  },
  methods: {
    createPrimaryDataset() {
      const self = this;
      // only do check if there is data (and it is local)
      if (self.diligenceData(self.category.selected).totalDataLength < 1)
        return;
      // do initial calculate for chart data
      self.datasets = [];
      self.labels = [];
      // let portfolioInfo = self.portfolioValueByProperty(self.category.selected);
      // let labels = portfolioInfo[self.category.selected];
      // labels = _.map(labels, lbl => {
      //   lbl = _.startCase(lbl);
      //   return lbl.length > 12 ? _.truncate(lbl, { length: 12 }) : lbl;
      // });
      self.labels.push(self.diligenceData(self.category.selected).labels);
      // create background colors...
      let bgColors = _.concat(
        vals.LEGEND.BACKGROUND_COLORS_1,
        vals.LEGEND.BACKGROUND_COLORS_2
      );
      self.datasets.push({
        header_label: self.diligenceData(self.category.selected).labels,
        data: self.diligenceData(self.category.selected)["value_p"],
        data_value: self.diligenceData(self.category.selected)["value"],
        backgroundColor: bgColors
      });
    },
    addDatasetForProperty(value, index) {
      const self = this;
      let values = self.diligenceData(self.category.selected).groupByData[
        value
      ];
      let finalObj = { value: [], value_p: [], names: [] };
      values.map(item => {
        finalObj.value.push(1);
        finalObj.value_p.push(((1 / values.length) * 100).toFixed(2));
        finalObj.names.push(item.name);
      });
      if (index > 9) index = index - 10;
      let bgColors = _.concat(subsetBackground(index), subsetBackground(index));
      if (values.length <= bgColors.length) {
        // we want 'other' to be grey (default color) - remove colors so that other is 'empty'
        bgColors = _.slice(bgColors, 0, values.length - 1);
      }
      // create the dataset...
      let dataset = {
        header_label: _.map(finalObj.names, n => {
          return value + " / " + n;
        }),
        data: finalObj.value_p,
        data_value: finalObj.value,
        backgroundColor: bgColors
      };
      // if there is already a second dataset, remove it
      if (self.datasets.length > 1)
        self.datasets = _.slice(self.datasets, 0, 1);
      // add new one
      self.datasets.push(dataset);
      self.datasets = _.without(self.datasets, undefined, null);
    },
    categoryChange() {
      const self = this;
      this.createPrimaryDataset();
      let totalCountObj = {
        text: self.diligenceCount,
        font: {
          size: "25",
          family: "custom-helvetica-medium,roboto"
        },
        color: "#050505"
      };
      self.textCenterLabel = [];
      self.textCenterLabel[0] = totalCountObj;
    }
  },
  mounted() {
    //this.diligenceData = this.$store.getters["charts/diligenceChart"];
    this.createPrimaryDataset();
  },
  watch: {
    diligenceCount: {
      handler(newData) {
        // updated portfolio, run update
        if (newData > 0) this.createPrimaryDataset();
      }
    },
    diligenceStageCount: {
      handler(newData) {
        // updated portfolio, run update
        if (newData > 0) this.createPrimaryDataset();
      }
    }
  }
};
</script>